import { array, bool, string } from "prop-types";
import NotLoggedIn from "./NotLoggedIn.jsx";
import LoggedIn from "./LoggedIn.jsx";

const propTypes = {
  formHTML: string,
  isLoggedIn: bool.isRequired,
  loggedInLinks: array,
};

const LoginButton = (props) => {
  const { isLoggedIn, formHTML, loggedInLinks } = props;

  if (isLoggedIn) {
    return <LoggedIn loggedInLinks={loggedInLinks} />;
  } else {
    return <NotLoggedIn formHTML={formHTML} />;
  }
};

LoginButton.propTypes = propTypes;
export default LoginButton;
